export const fetchCourseApprovalTutorsTypes = [
  'FETCH_COURSE_APPROVAL_TUTORS',
  'FETCH_COURSE_APPROVAL_TUTORS_SUCCESS',
  'FETCH_COURSE_APPROVAL_TUTORS_FAIL',
];

export const updateCourseApprovalTypes = [
  'UPDATE_COURSE_APPROVAL',
  'UPDATE_COURSE_APPROVAL_SUCCESS',
  'UPDATE_COURSE_APPROVAL_FAIL',
];

export const addCoursesToTutorTypes = [
  'ADD_COURSES_TO_TUTOR',
  'ADD_COURSES_TO_TUTOR_SUCCESS',
  'ADD_COURSES_TO_TUTOR_FAIL',
];

export const SELECT_COURSE_APPROVAL_TUTOR = 'SELECT_COURSE_APPROVAL_TUTOR';
export const SELECT_COURSE_APPROVAL_TUTOR_UNIVERSITY = 'SELECT_COURSE_APPROVAL_TUTOR_UNIVERSITY';



// WEBPACK FOOTER //
// ./src/modules/course_approvals/action_types.js